import type { Chart, ChartType, Plugin } from 'chart.js'
import { setCursor } from '../utils/cursor'

const PLUGIN_ID = 'indicateClickOnBubbleHover'

const hoveredByChart = new WeakMap<Chart, number | null>()

export const indicateClickOnBubbleHover: Plugin<ChartType> = {
  id: PLUGIN_ID,

  afterEvent(chart, args) {
    const ev = args.event

    if (ev.type === 'mouseout') {
      hoveredByChart.delete(chart)
      setCursor(chart, PLUGIN_ID, null)

      return
    }

    if (ev.type !== 'mousemove') return

    const native = ev.native as Event | null

    if (!native) return

    const hits = chart.getElementsAtEventForMode(
      native,
      'nearest',
      { intersect: true },
      true
    )

    const prev = hoveredByChart.get(chart) ?? null
    const next = hits.length ? hits[0].datasetIndex : null

    if (prev !== next) {
      hoveredByChart.set(chart, next)
      setCursor(chart, PLUGIN_ID, next !== null ? 'pointer' : null)
    }
  }
}
